var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonepending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#81B2DA"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_14950_97_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.009 0 0 0.009 15 15)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1222.22,
    y: -1222.22,
    width: 2444.44,
    height: 2444.44
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(255, 255, 255, 1) 0deg,rgba(255, 255, 255, 0.2) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 15C23 19.4183 19.4183 23 15 23V25C20.5228 25 25 20.5228 25 15H23ZM15 23C10.5817 23 7 19.4183 7 15H5C5 20.5228 9.47715 25 15 25V23ZM7 15C7 10.5817 10.5817 7 15 7V5C9.47715 5 5 9.47715 5 15H7ZM15 7C19.4183 7 23 10.5817 23 15H25C25 9.47715 20.5228 5 15 5V7Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.20000000298023224},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.20000000298023224},\"position\":1.0}],\"transform\":{\"m00\":18.0,\"m01\":-1.3418235706580406e-12,\"m02\":6.0,\"m10\":1.6895454219706396e-12,\"m11\":18.0,\"m12\":6.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_14950_97_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 15C23 19.4183 19.4183 23 15 23V25C20.5228 25 25 20.5228 25 15H23ZM15 23C10.5817 23 7 19.4183 7 15H5C5 20.5228 9.47715 25 15 25V23ZM7 15C7 10.5817 10.5817 7 15 7V5C9.47715 5 5 9.47715 5 15H7ZM15 7C19.4183 7 23 10.5817 23 15H25C25 9.47715 20.5228 5 15 5V7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonepending);
export default __webpack_public_path__ + "static/media/donepending.3a4c2ae359ce3f9b66a06bf14c2b3993.svg";
export { ForwardRef as ReactComponent };